import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Data } from '../../core/services/data';
import { NewsItem } from '../../core/models/news';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home.html'
})
export class Home implements OnInit {
  private dataService = inject(Data);
  private sanitizer = inject(DomSanitizer);

  newsItems: NewsItem[] = [];
  isLoading = true;
  error: string | null = null;

  ngOnInit() {
    this.loadNews();
  }

  loadNews() {
    this.dataService.getNews().subscribe({
      next: (data) => {
        this.newsItems = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading news:', err);
        this.error = 'Fehler beim Laden der Nachrichten';
        this.isLoading = false;
      }
    });
  }

  // Sanitize HTML content for safe rendering
  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.sanitize(1, html) || '';
  }
}
